import React from 'react'
import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';

const InfoDialog = ({children, desc}) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-blackA6 data-[state=open]:animate-overlayShow" />
        <Dialog.Content className="fixed left-1/2 md:top-[60%] top-[60%] max-h-[75dvh] md:max-h-[80dvh] overflow-y-auto md:w-[1000px] w-[94%] -translate-x-1/2 -translate-y-1/2 rounded-md bg-gray1 shadow-[var(--shadow-6)] focus:outline-none data-[state=open]:animate-contentShow bg-[#ACCAE7]/50 backdrop-blur-xl text-[#274760] p-4 z-[100]">
          <div className="flex flex-col gap-[7px] mt-3">
            <h1 className="text-center text-xl">{desc.title}</h1>
            <p className="text-justify">{desc.desc1}</p>
            <p className="text-justify">{desc.desc2}</p>
            <p className="text-center font-semibold">{desc.footer}</p>
          </div>
          <Dialog.Close asChild>
            <button
              className="absolute right-2.5 top-2.5 inline-flex size-[25px] appearance-none items-center justify-center rounded-full text-violet11 bg-gray3 hover:bg-violet4 focus:shadow-[0_0_0_2px] focus:shadow-violet7 focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default InfoDialog